import Vue from 'vue';
import Router from 'vue-router';
import Home from '@/components/Home';
import Shared from '@/components/Shared';
import Contacts from '@/components/Contacts';
import Ideas from '@/components/Ideas';
import Login from '@/components/Login';
import 'firebase/auth';

Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home,
    },
    {
      path: '/shared',
      name: 'Shared content',
      component: Shared,
    },
    {
      path: '/ideas',
      name: 'Ideas submitted',
      component: Ideas,
    },
    {
      path: '/contacts',
      name: 'Contacts',
      component: Contacts,
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
    },
  ],
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js